export default "__VITE_ASSET__CVhJgrdz__"